import React from 'react'

import { classNames } from '@lib/simpleFn'

type ChangeQPPButtonProps = {
  buttonHandler: () => void
  theNumberOfQuestionToChange: number
  isSelected: boolean
}

const ChangeQPPButton: React.FC<ChangeQPPButtonProps> = ({
  buttonHandler,
  theNumberOfQuestionToChange,
  isSelected,
}) => {
  const renderingHorizontalLine = () => {
    const HLines = []
    for (let i = 1; i < theNumberOfQuestionToChange; i++) {
      HLines.push(
        <div
          key={i}
          className={classNames(
            'mx-auto h-[100%] w-fit border',
            isSelected ? 'border-white' : 'border-cbtLayout'
          )}
        />
      )
    }
    return HLines
  }
  return (
    <button onClick={!isSelected ? buttonHandler : undefined}>
      <div
        className={classNames(
          'w-8 1.1xl:w-11 h-8 1.1xl:h-11 mb-1 border  mx-auto rounded-md',
          isSelected ? 'bg-bosalpim border-white' : 'bg-white border-cbtLayout'
        )}
      >
        {renderingHorizontalLine()}
      </div>
    </button>
  )
}

export default ChangeQPPButton
